<template>
  <div class="animated fadeIn">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <b-col sm="12" lg="8" class="pt-2 p-1 title">
              <span :title="corporationSelected && corporationSelected.name">Relatório de Operações - {{corporationSelected && corporationSelected.name}}</span>
            </b-col>
          </div>
          <b-form @submit.stop.prevent>
            <b-form-group label="Início" label-for="txt-data-inicio">
              <b-form-input type="date" id="txt-data-inicio" v-model="filters.initDate" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
            </b-form-group>

            <b-form-group label="Fim" label-for="txt-data-fim">
              <b-form-input type="date" id="txt-data-fim" v-model="filters.endDate" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
            </b-form-group>

            <b-form-group label="" label-for="all-by-month">
              <b-form-checkbox id="all-by-month" v-model="filters.byMonth" name="all-by-month">
                Mostrar por mês
              </b-form-checkbox>
            </b-form-group>

            <div slot="footer">
              <b-row>
                <b-col sm="12" lg="2">
                  <b-button variant="secondary" class="form-control" @click="download">Download</b-button>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { requestError, env, formatDate } from '@/shared/utils'
import _ from 'underscore'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'report_users_operation',
  components: {
    Loading
  },
  data: function() {
    return {
      filters: {},
      loadCount: 0,
    }
  },
  computed: {
    ...mapState(['corporationSelected']),
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    async download () {
      if (!this.filters.initDate || !this.filters.endDate) {
        return alert("O período deve ser informado!");
      }
      this.loadCount++;
      var format = "csv";
      var _this = this;
      let urlGet = `${env.urlBillingApi}/operation-count?initDate=${this.filters.initDate}&endDate=${this.filters.endDate}&report=true&format=${format}`;
      if (this.filters.byMonth) {
        urlGet += '&byMonth=true';
      }
      await axios
        .get(urlGet,
          { responseType: 'arraybuffer' })
        .then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `operacoes-por-usuario-${+ new Date()}.${format}`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-usuarios-atual, #card-chart-usuarios-total, #card-chart-usuarios-pico, #card-chart-usuarios-ativos, #volumes-chart {
    width: 100% !important;
  }
</style>

<style scoped>
  .title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>